"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("../../../styles");

var styles = {
  base: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    transition: '0.3s all'
  },
  primary: {
    extend: 'base',
    height: '100%',
    margin: '0 20px',
    color: _styles.colors.koala
  },
  primaryActive: {
    extend: 'primary',
    color: _styles.colors.white
  },
  secondary: {
    extend: 'primary'
  },
  secondaryActive: {
    extend: 'primaryActive'
  },
  aside: {
    extend: 'base',
    color: _styles.colors.white,
    height: '35px',
    width: '100%',
    margin: '5px 0',
    padding: '0 0 0 30px',
    fontWeight: 300,
    '&:hover': {
      background: _styles.colors.raven
    },
    '&:focus': {
      outline: 'none',
      background: _styles.colors.raven
    }
  },
  asideActive: {
    extend: 'aside',
    background: _styles.colors.raven,
    fontWeight: 500,
    borderLeft: "3px solid ".concat(_styles.colors.blue)
  }
};
var _default = styles;
exports["default"] = _default;